import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Hello!',
  ProductCode: 'eti46',
  Description:
    'Here\'s all the online content included with your <strong>English Literature Text Guide</strong>.',
  Credits:
    '<i>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',
  FreeSampleContent:
    '<p>This is a free sample of the CGP RevisionHub for the GCSE English Literature Text Guides. <a href="[[external_domain]]/info/new-gcse-english-literature-books" class="link-button" style="color: #FF9335;">Order</a> your book now for full access to online English revision.</p>',};